import { components } from '../../tokens/components/cobalt';
import { DeprecatedTheme } from '../types';
import colors from './colors/TR';
import alertTokens from './components/alert.tokens';
import createButtonTokens from './components/button.tokens';
import createCalendarTokens from './components/calendar.tokens';
import checkboxTokens from './components/checkbox.tokens';
import drawerHeaderTokens from './components/drawerHeader.tokens';
import inputTokens from './components/input.tokens';
import radioButtonBoxTokens from './components/radioButton.tokens';
import sliderTokens from './components/slider.tokens';
import switchSliderTokens from './components/switchSlider.tokens';
import ED from './ED';

const { borders, space, fontWeights, fontSizes, radii, sizes, lineHeights } =
  ED;

const fontSizeBody = fontSizes.body;

const button = createButtonTokens({
  colors,
  radii,
  borders,
  space,
  fontSizeBody,
});

const drawerHeader = drawerHeaderTokens({
  colors,
  borders,
  space,
});

const switchSlider = switchSliderTokens({ colors, space });

const slider = sliderTokens({
  colors,
  sizes,
  space,
  fontSizeBody,
});

const checkbox = checkboxTokens({
  borders,
  colors,
  space,
  lineHeights,
  fontSizeBody,
  sizes,
});

const radioButton = radioButtonBoxTokens({
  borders,
  colors,
  lineHeights,
  fontSizeBody,
  fontWeights,
  sizes,
});

const input = inputTokens({
  fontSizes,
  lineHeights,
  colors,
});

const alert = alertTokens({ colors, borders });
const calendar = createCalendarTokens({ colors });

const COBALT_TR: DeprecatedTheme = {
  ...ED,
  colors: {
    ...colors,
    text: colors,
    button: button.colors,
    drawerHeader: drawerHeader.colors,
    slider: slider.colors,
    checkbox: checkbox.colors,
    radioButton: radioButton.colors,
    brandedProgressBar: colors.primary['30'],
    switchSlider: {
      ...switchSlider.colors,
      bg: colors.neutral['50'],
    },
    input: input.colors,
    alert: alert.colors,
    brandedHeaderBg: colors.primary['50'],
    calendar: calendar.colors,
  },
  borders: {
    ...borders,
    alert: alert.borders,
  },
  components,
};

export default COBALT_TR;
